<template>
  <div>
    <p class="main-label">Pontuação para qualificação de leads:</p>

    <d-form-row>
      <d-col md="full" lg="4" xl="2" class="form-group">
        <label class="label" for="lead-score-low-max">
          Baixa prioridade até
        </label>

        <d-form-input
          id="lead-score-low-max"
          v-model.number="model.leadScoreLowMaximum"
          type="number"
          :min="SCORE_MIN"
          :max="SCORE_MAX - SCORE_OFFSET"
          :state="isValid"
          @change="onLowChange"
        />
      </d-col>

      <d-col md="full" lg="4" xl="2" class="form-group">
        <label class="label" for="lead-score-high-min">
          Alta prioridade a partir de
        </label>

        <d-form-input
          id="lead-score-high-min"
          v-model.number="model.leadScoreHighMinimum"
          type="number"
          :min="SCORE_MIN + SCORE_OFFSET"
          :max="SCORE_MAX"
          :state="isValid"
          @change="onHighChange"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col md="full" lg="4" class="form-group">
        <p class="text-muted mb-0 label">
          Média prioridade:
          <span class="font-weight-bold">
            {{ mediumScoreLabel }}
          </span>
          (calculado automaticamente)
        </p>
      </d-col>
    </d-form-row>
  </div>
</template>

<script>
const SCORE_MIN = 0;
const SCORE_MAX = 100;
const SCORE_OFFSET = 2;

export default {
  name: 'settings-lead-score',

  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      SCORE_MIN,
      SCORE_MAX,
      SCORE_OFFSET,
    };
  },

  computed: {
    scoreLimits() {
      return {
        low: Number(this.model.leadScoreLowMaximum),
        high: Number(this.model.leadScoreHighMinimum),
      };
    },

    isValid() {
      const { low, high } = this.scoreLimits;

      return (
        Number.isInteger(low) &&
        Number.isInteger(high) &&
        low >= SCORE_MIN &&
        high <= SCORE_MAX &&
        high >= low + SCORE_OFFSET
      );
    },

    mediumScoreLabel() {
      const { low, high } = this.scoreLimits;

      if (!this.isValid) {
        return 'N/A';
      }

      if (high === low + SCORE_OFFSET) {
        return `${low + 1}`;
      }

      return `${low + 1}–${high - 1}`;
    },
  },

  methods: {
    onLowChange() {
      const { low, high } = this.scoreLimits;

      if (low > high - SCORE_OFFSET) {
        this.model.leadScoreHighMinimum = low + SCORE_OFFSET;
      }
    },

    onHighChange() {
      const { low, high } = this.scoreLimits;

      if (high < low + SCORE_OFFSET) {
        this.model.leadScoreLowMaximum = high - SCORE_OFFSET;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-label {
  margin-bottom: 0.5rem;
}

.label {
  font-size: 0.85rem;
}
</style>
